// extracted by mini-css-extract-plugin
export default {"title":"DialogDelete_title__HrbzC","description":"DialogDelete_description__asib3","wrapper":"DialogDelete_wrapper__ZDdCG","buttonProgress":"DialogDelete_buttonProgress__OLbVV"};